// TODO: Use formik status for when suggestion item is
//       selected and use with validation

import React, { useState, useEffect, Fragment, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { log } from '../../Helpers/helpers';
import withGeolocation from '../../Containers/withGeolocation';
import classNames from 'classnames';
import { shape, object, string } from 'prop-types';
import { Formik } from 'formik';
import { withRouter } from 'react-router';
import queryString from 'qs';
import FullscreenModal from '../../Modal/fullscreen-modal';
import CONSTANTS from '../../Pages/findcare/constants';
import { isFalseOrEmpty } from '../../Helpers/helpers';
import { OpenModalButton } from '../../Modal';
import CategoriesLists from '../findcare-categories-lists';
import UnitSuggestion from './UnitSuggestion';
import CaretypeSuggestion from './CaretypeSuggestion';
import LocationSuggestion, {
  getDefaultLocations,
  getNearby,
} from './LocationSuggestion';
import InputLatLng from './inputLatLng';
import { isTrue, isFalse, getAOCategories } from './helpers';

// This is a work around for uuid 8.1.0 / react-native not supporting crypto API in node.js. We don't really need
// cryptographically strong sequences, but they should be non-repeating since they are meant to be unique for Google API
// session token.
function get16RandomBytes() {
  var random = new Array(16);
  for (var i = 0; i < 16; ++i) {
    var d = new Date();
    random[i] = (Math.floor(Math.random() * 256) + d.getTime()) % 256;
  }
  return random;
}

const FindCareForm = (props) => {
  const translations = props.Content.Translations;

  const hjvSearchForm = useRef(null);
  const caretypeWrapper = useRef(null);

  const [activeElement, setActiveElement] = useState(
    typeof document !== 'undefined' ? document.activeElement : null
  );
  const [sessionToken, setSessionToken] = useState(
    uuidv4({ rng: () => get16RandomBytes() })
  );

  const handleFocusIn = () => {
    setActiveElement(document.activeElement);
  };

  useEffect(() => {
    document.addEventListener('focusin', handleFocusIn);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, [handleFocusIn]);

  useEffect(() => {
    const newSessionToken = uuidv4({ rng: () => get16RandomBytes() });
    setSessionToken(newSessionToken);
  }, []);

  const setSortField = (formik) => {
    let sort = CONSTANTS.SORT_NAME;
    const { values } = formik;

    if (values.nearby && values.lat && values.lng) {
      sort = CONSTANTS.SORT_DISTANCE;
    } else if (values.q !== '' && values.location === '') {
      sort = CONSTANTS.SORT_REL;
    } else if ((values.lat && values.lng) || values.location !== '') {
      sort = CONSTANTS.SORT_DISTANCE;
    } else if (values.location === '') {
      sort = CONSTANTS.SORT_NAME;
    } else {
      sort = CONSTANTS.SORT_NAME;
    }

    formik.setFieldValue('s', sort);
  };

  const handleSubmit = (/* values */) => {
    hjvSearchForm.current.submit();
  };

  const handleChange = (formik) => (e) => {
    setSortField(formik);
    formik.handleChange(e);
  };

  const getFieldProps = (formik, name) => {
    return {
      setValue: formik.setFieldValue,
      setStatus: (value) =>
        formik.setStatus({ ...formik.status, [name]: value }),
      clearField: () => formik.setFieldValue(name, ''),
      error: formik.errors[name],
      isTouched: formik.touched[name],
      value: formik.values[name],
      onChange: handleChange(formik),
      onBlur: formik.handleBlur,
      name: name,
    };
  };

  const validate = (values) => {
    let errors = {};
    if (
      (values.location === 'Nära mig' || isTrue(values.nearby)) &&
      (!values.lat || !values.lng)
    ) {
      // TODO: Translation
      errors.location =
        'Sortering på avstånd är inte möjligt eftersom vi inte kan fastställa din position. Se till att aktivera platstjänster.';
    }
    if (
      values.region.length === 0 &&
      values.location.length > 0 &&
      values.ls === false &&
      values.location !== 'Hela landet'
    ) {
      errors.ls = 'No location set';
    }
    if (values.caretype.length > 0 && values.caretypeSet === false) {
      errors.caretypeSet = 'No caretype selected';
    }

    return errors;
  };

  const getCaretypeGValue = (formik) => {
    if (formik.values.g) {
      return formik.values.g;
    }
    if (props.Content.Region) {
      return props.Content.Region.Value;
    }
    return '';
  };

  const {
    location,
    Content: { SearchResult },
  } = props;

  const query = queryString.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const HasCareTypeFilter = props.hasCareTypeFilter;

  // use query param by default if they are available as initial values.
  const initialValues = {
    q: query.q || '',
    g: query.g || '',
    lat: query.lat || '',
    lng: query.lng || '',
    region: query.region || '',
    // ls: locationSet: use for validation when a value is selected
    // When we have a value caretypeSet should be true initially.
    ls: query.location ? true : false,
    // caretypeSet: use for validation when a value is selected.
    // When we have a value caretypeSet should be true initially.
    // Either Hardcorded value or querystring.
    caretypeSet: query.caretype ? true : false,
    nearby: query.nearby || false,
    s: query.s,
    location: query.location || '', // sry
    caretype: query.caretype || '',
    st: sessionToken,
  };

  return (
    <Fragment>
      <div
        className={classNames('findcare-form', {
          'findcare-form--has-searchresult': SearchResult,
        })}
      >
        <Formik
          initialStatus={{}}
          validate={validate}
          onSubmit={handleSubmit}
          initialValues={initialValues}
        >
          {(formik) => (
            <form
              action={location.pathname}
              method="get"
              ref={hjvSearchForm}
              onSubmit={formik.handleSubmit}
            >
              <input type="hidden" defaultValue={formik.values.st} name="st" />
              <input
                type="hidden"
                defaultValue={formik.values.nearby}
                name="nearby"
              />
              <input type="hidden" defaultValue={formik.values.s} name="s" />
              <input type="hidden" defaultValue={formik.values.g} name="g" />

              <InputLatLng
                coords={props.coords}
                formik={formik}
                handleChange={() => handleChange(formik)}
                lat={getFieldProps(formik, 'lat')}
                lng={getFieldProps(formik, 'lng')}
              />

              <fieldset className="findcare-form__fieldset">
                <legend className="show-for-sr">Hitta vård</legend>

                <div className="findcare-form__wrapper">
                  {HasCareTypeFilter && props.Content.CommonCareTypes && (
                    <FullscreenModal
                      hideWithCss={true}
                      id="findcare-dropdown__category-lists"
                      classModifier="category-lists-modal"
                    >
                      <CategoriesLists
                        {...props}
                        careTypeChangeHandler={(careType) => {
                          formik.setFieldValue('caretype', careType);
                          formik.setFieldValue('caretypeSet', true);
                          // next tick
                          setTimeout(() => {
                            caretypeWrapper.current.focus();
                          }, 0);
                        }}
                        selectedCareType={formik.values.caretype}
                      />
                    </FullscreenModal>
                  )}

                  {/* 

                    Plats: Var vill du söka vård 

                    */}
                  <div
                    className="form-field findcare-searchfield__location-wrapper"
                    data-cy="ui-location-field"
                  >
                    <LocationSuggestion
                      activeElement={activeElement}
                      isSelected={formik.values.ls}
                      inputClassName={
                        isFalse(formik.values.nearby)
                          ? 'region'
                          : 'nearby region'
                      }
                      innerClassName="findcare-search__field__query"
                      errorClassName="findcare-region-search-field__error"
                      className="findcare-searchfield"
                      zeroHitsMessage={
                        formik.values.nearby ||
                        formik.values.ls ||
                        formik.values.location === 'Hela landet'
                          ? false
                          : 'Vi kan inte hitta den platsen'
                      }
                      {...getFieldProps(formik, 'location')}
                      onValueChange={() => {
                        // location changes
                        formik.setFieldValue('ls', false, false);
                        formik.setFieldValue('g', '', false);
                        formik.setFieldValue('nearby', false, true);
                        // formik.validateForm().then(() => {});
                      }}
                      onSuggestionSelect={(item) => {
                        if (item.IsNearBy && props.coords === null) {
                          log('error')('No geoposition!');
                          formik.setFieldValue('nearby', true, true);
                        } else {
                          // location selected
                          formik.setFieldValue('ls', true, true);
                          formik.setFieldValue(
                            's',
                            CONSTANTS.SORT_DISTANCE,
                            false
                          );
                          formik.setFieldValue('nearby', !!item.IsNearBy, true);
                          const g = item.Type === 'g' ? item.Value : '';
                          formik.setFieldValue('g', g);

                          // Make sure all `setFieldValues` have run.
                          // They use setState internally and are async.
                          setTimeout(function delayedValidate() {
                            formik.validateForm();
                          }, 0);
                        }
                      }}
                      clearField={() => {
                        // location text cleared
                        formik.setValues({
                          ...formik.values,
                          location: '',
                          g: '',
                          nearby: false,
                        });

                        formik.validateForm().then(() => {});
                      }}
                      getItems={(item) => {
                        let extra = [getNearby()];
                        if (
                          formik.values.location === 'Hela landet' ||
                          isTrue(formik.values.nearby)
                        ) {
                          extra = getDefaultLocations(
                            props.Content.Region,
                            props.Content.Translations.allcounties
                          );
                        }
                        if (item.Suggestions && item.Suggestions.Hits) {
                          const items = item.Suggestions.Hits.Items || [];
                          const itemsWithExtra = extra.concat(items);
                          return itemsWithExtra.map((item) => ({
                            text: item.Name,
                            key: item.Value,
                            ...item,
                          }));
                        }
                        return [];
                      }}
                      sessiontoken={sessionToken}
                      defaultSuggestionsTitle={'Förslag på platser'}
                      defaultSuggestions={getDefaultLocations(
                        props.Content.Region,
                        props.Content.Translations.allcounties
                      )}
                      label={translations.where}
                      labelClassName="findcare-form__label"
                      placeholder={translations.whereinputfield}
                    />
                  </div>

                  {/* 

                    Vårdtyp: Vilken typ av vård söker du
                    
                    */}
                  {!HasCareTypeFilter ? (
                    <input
                      type="hidden"
                      name="caretype"
                      value={formik.values.caretype}
                    />
                  ) : (
                    <div
                      ref={caretypeWrapper}
                      tabIndex="-1"
                      className="form-field findcare-searchfield__caretype-wrapper"
                      data-cy="ui-caretype-field"
                    >
                      <CaretypeSuggestion
                        activeElement={activeElement}
                        isSelected={formik.values.caretypeSet}
                        nearby={isTrue(formik.values.nearby)}
                        st={formik.values.st}
                        g={getCaretypeGValue(formik)}
                        lat={formik.values.lat}
                        lng={formik.values.lng}
                        innerClassName="findcare-search__field__query"
                        className="findcare-searchfield"
                        errorClassName="findcare-region-search-field__error"
                        zeroHitsMessage={
                          formik.values.caretypeSet
                            ? null
                            : 'Det finns ingen vårdtyp med detta namn'
                        }
                        onSuggestionSelect={() => {
                          formik.setFieldValue('caretypeSet', true);
                          // Make sure all `setFieldValues` have run.
                          // They use setState internally and are async.
                          setTimeout(function delayedValidate() {
                            formik.validateForm();
                          }, 0);
                        }}
                        onValueChange={() => {
                          formik.setFieldValue('caretypeSet', false);
                        }}
                        clearField={() => {
                          formik.setFieldValue('caretypeSet', false);
                        }}
                        suggestionsFallback={getAOCategories(
                          props.Content.AOCareTypes
                        )}
                        getItems={(props) => {
                          if (
                            props.Suggestions &&
                            props.Suggestions.Hits &&
                            props.Suggestions.Hits.length > 0
                          ) {
                            return props.Suggestions.Hits.map((item) => {
                              return typeof item === 'string'
                                ? {
                                    text: item,
                                    key: item,
                                  }
                                : {
                                    text: item.Value,
                                    key: item.Value,
                                  };
                            });
                          }
                          return [];
                        }}
                        hightlightTitle={props.Content.Translations.within}
                        suggestionsTitle={null}
                        defaultSuggestionsTitle={'Vanliga vårdtyper'}
                        defaultSuggestions={props.Content.CommonCareTypes.Options.map(
                          (item) => ({
                            text: item.Label,
                            value: item.Name,
                            key: item.Value,
                          })
                        )}
                        {...getFieldProps(formik, 'caretype')}
                        suggestionsFooter={(isOpen) => (
                          <div className="findcare-searchfield__autocomplete__item caretype-footer">
                            <OpenModalButton
                              tabIndex={isOpen ? 0 : -1}
                              className="findcare-dropdown__panel__footer"
                              id="findcare-dropdown__category-lists"
                              clickCallback={() => {
                                //setState({ isOpen: false });
                                setTimeout(() => {
                                  document
                                    .querySelector('.categories-lists__heading')
                                    .focus();
                                }, 0);
                              }}
                              fullScreen={true}
                            >
                              {translations.more}
                            </OpenModalButton>
                          </div>
                        )}
                        labelClassName="findcare-form__label"
                        placeholder={translations.choiceunitinputfield}
                        highlightSelection={true}
                        label={translations.choiceunit}
                      />
                    </div>
                  )}
                  {/* 

                    Mottagning: Vilken mottagning söker du? 

                    */}
                  <div className="form-field findcare-searchfield__unit-wrapper">
                    <UnitSuggestion
                      activeElement={activeElement}
                      doNotAutoselectFirstItemOnClose={true}
                      zeroHitsMessage={null}
                      nearby={isTrue(formik.values.nearby)}
                      st={formik.values.st}
                      g={formik.values.g}
                      caretype={
                        formik.values.caretypeSet &&
                        formik.values.caretype !==
                          props.Content.Translations.allunits
                          ? formik.values.caretype
                          : ''
                      }
                      lat={formik.values.lat}
                      lng={formik.values.lng}
                      innerClassName="findcare-search__field__query"
                      className="findcare-searchfield"
                      {...getFieldProps(formik, 'q')}
                      getItems={(props) => {
                        if (props.Suggestions && props.Suggestions.Hits) {
                          const { Units } = props.Suggestions.Hits;
                          return Units
                            ? Units.map((item) => ({
                                ...item,
                                value: item.DisplayName,
                                text: (
                                  <>
                                    <span style={{ display: 'block' }}>
                                      {item.DisplayName}
                                    </span>
                                    <small className="findcare-autocomplete__sublabel">
                                      {item.Address}
                                    </small>
                                  </>
                                ),
                                key: `suggestion_unit_${item.HsaId}`,
                              }))
                            : [];
                        }
                        return [];
                      }}
                      label={translations.unit}
                      labelClassName="findcare-form__label"
                      onSuggestionSelect={(selectedObject) => {
                        if (selectedObject.FriendlyUrl) {
                          window.location.href = selectedObject.FriendlyUrl;
                          return '';
                        } else {
                          return selectedObject.DisplayName;
                        }
                      }}
                      suggestCloseButton={true}
                      suggestionsTitle={translations.suggestions}
                      placeholder={translations.unitinputfield}
                    />
                  </div>
                  <button
                    type="submit"
                    className={classNames({
                      'findcare-form__button': true,
                      'findcare-form__button--is-disabled': !isFalseOrEmpty(
                        formik.errors
                      ),
                    })}
                  >
                    {translations.searchbutton}
                  </button>
                </div>
              </fieldset>
            </form>
          )}
        </Formik>
      </div>
    </Fragment>
  );
};

FindCareForm.defaultProps = {
  Regionalization: {},
};

FindCareForm.propTypes = {
  Content: shape({
    Translations: shape({
      choiceunit: string,
    }),
  }),
  /** From react-router withRouter() higher order component */
  history: object,
  /** From react-router withRouter() higher order component */
  location: object,
};

export default withRouter(withGeolocation(FindCareForm));
